<div class="box">
    <img src="/assets/img/403.png" width="400" />
    <p>{{ translate.instant('COMMON.YOU_DONT_HAVE_PERMISSION_TO_ACCESS')}}</p><br>
    <button style="color: white" mat-raised-button type="submit" color="primary">{{
        translate.instant('COMMON.RETURN_TO_THE_MAIN_PAGE') }}</button>
</div>